/** Other open cases on the same customer, never the case you are viewing. */
export function siblingCasesExcludingCurrent(cases, currentCaseId) {
  if (!Array.isArray(cases)) return [];
  return cases.filter((row) => String(row?.id) !== String(currentCaseId));
}

export function isClosedCaseStatus(status) {
  return String(status || "").toUpperCase() === "CLOSED";
}

/** Target case this record was transferred to, or null. */
export function caseTransferredTo(caseItem) {
  const to = caseItem?.transferred_to_case;
  return to?.id ? to : null;
}

/** Source cases that were transferred into this record. */
export function caseTransferredFrom(caseItem) {
  if (!Array.isArray(caseItem?.transferred_from_cases)) return [];
  return caseItem.transferred_from_cases.filter((row) => row?.id);
}

/** Open sibling cases for the header tag; hidden on closed cases. */
export function siblingOpenCasesForHeader(cases, currentCaseId, status) {
  if (isClosedCaseStatus(status)) return [];
  return siblingCasesExcludingCurrent(cases, currentCaseId);
}

/** Compact label for a related case link. */
export function caseRelationLabel(row) {
  if (!row) return "";
  if (row.displayTitle) return String(row.displayTitle);
  const number =
    row.case_number != null && String(row.case_number).trim() !== ""
      ? `SAK-${row.case_number}`
      : "";
  if (number && row.title) return `${number} – ${row.title}`;
  return number || String(row.title || row.id || "");
}
